module.exports = __webpack_public_path__ + "media/images/camera_pause-cbdbdaccf628b30b406844802010dec50a33a45d0cb092252d5969275c5795fe.svg";